var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.790039,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#FF886D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8337_42764)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8337_42764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 17.457C22.6403 17.457 16.667 23.4304 16.667 30.7903C16.667 38.1503 22.6403 44.1237 30.0003 44.1237C37.3603 44.1237 43.3337 38.1503 43.3337 30.7903C43.3337 23.4304 37.3603 17.457 30.0003 17.457ZM30.0003 26.457C29.4537 26.457 29.0003 26.0037 29.0003 25.457C29.0003 24.9103 29.4537 24.457 30.0003 24.457C33.4937 24.457 36.3337 27.297 36.3337 30.7903C36.3337 34.2837 33.4937 37.1237 30.0003 37.1237C29.4537 37.1237 29.0003 36.6703 29.0003 36.1237C29.0003 35.577 29.4537 35.1237 30.0003 35.1237C32.387 35.1237 34.3337 33.177 34.3337 30.7903C34.3337 28.4037 32.387 26.457 30.0003 26.457ZM30.0003 41.1237C24.307 41.1237 19.667 36.4837 19.667 30.7903C19.667 30.2437 20.1203 29.7903 20.667 29.7903C21.2137 29.7903 21.667 30.2437 21.667 30.7903C21.667 35.3903 25.4003 39.1237 30.0003 39.1237C34.6003 39.1237 38.3337 35.3903 38.3337 30.7903C38.3337 26.1903 34.6003 22.457 30.0003 22.457C29.4537 22.457 29.0003 22.0037 29.0003 21.457C29.0003 20.9104 29.4537 20.457 30.0003 20.457C35.6937 20.457 40.3337 25.097 40.3337 30.7903C40.3337 36.4837 35.6937 41.1237 30.0003 41.1237Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8337_42764"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8337_42764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14.79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundOrange);
export default __webpack_public_path__ + "static/media/backgroundOrange.6e3b927cc0ca328a01befec3588357f0.svg";
export { ForwardRef as ReactComponent };